export default "<div id=\"user-settings\">\n    <div ng-if=\"!authorized\" class=\"unauthorized-container\">\n        <log-in></log-in>\n    </div>\n</div>\n";